var render = function render(){var _vm=this,_c=_vm._self._c;return _c('warning',{attrs:{"icon":_vm.$icons.warning,"title":_vm.$t('accountNotFound.title', { supplier: _vm.$t(`accountNotFound.${_vm.supplier}`) }),"content":_vm.$t('accountNotFound.details', { supplier: _vm.$t(`accountNotFound.${_vm.supplier}`) }),"show-back":false,"show-home":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }